import { PostEntity, PostSchema, TopicEntity, TopicSchema } from 'mk2/apps/forum/schemas';
import { initialState } from 'mk2/apps/home/containers/Home/Home.constants';
import { State } from 'mk2/apps/home/containers/Home/Home.reducers';
import {
    HomeCounsellingEntity,
    HomeCounsellingSchema,
    HomePhotoblogPostEntity,
    HomePhotoblogPostSchema,
    HomePostEntity,
    HomePostSchema,
} from 'mk2/apps/home/schemas';
import { MinStrollerSchema, StrollerMinEntity } from 'mk2/apps/strollers/schemas';
import { ExperienceEntity, ExperienceSchema } from 'mk2/apps/wiki/schemas';
import { AppState } from 'mk2/reducers';
import { createDenormalizedEntitiesSelector, createDenormalizedEntitySelector } from 'mk2/selectors';

export const getHomeState = (state: AppState): State =>
    state.containers.home.home || initialState;

const getDenormalizedForumPosts = createDenormalizedEntitiesSelector<PostEntity>();
export const getHomeForumPosts = (state: AppState): PostEntity[] => getDenormalizedForumPosts(state, PostSchema, getHomeState(state).forumPostsIds);

const getDenormalizedContests = createDenormalizedEntitiesSelector<PostEntity>();
export const getHomeContestPosts = (state: AppState): PostEntity[] => getDenormalizedContests(state, PostSchema, getHomeState(state).contestPostsIds);

const getDenormalizedContestTopic = createDenormalizedEntitySelector<TopicEntity>();
export const getHomeContestTopic = (state: AppState): TopicEntity => getDenormalizedContestTopic(state, TopicSchema, getHomeState(state).contestTopicId);

const getDenormalizedWikiExperiences = createDenormalizedEntitiesSelector<ExperienceEntity>();
export const getHomeWikiExperiences = (state: AppState): ExperienceEntity[] => getDenormalizedWikiExperiences(state, ExperienceSchema, getHomeState(state).wikiExperiencesIds);

const getDenormalizedPhotoblogPosts = createDenormalizedEntitiesSelector<HomePhotoblogPostEntity>();
export const getHomePhotoblogPosts = (state: AppState): HomePhotoblogPostEntity[] => getDenormalizedPhotoblogPosts(state, HomePhotoblogPostSchema, getHomeState(state).photoblogPostsIds);

const getDenormalizedHomePosts = createDenormalizedEntitiesSelector<HomePostEntity>();
export const getHomePosts = (state: AppState): HomePostEntity[] => getDenormalizedHomePosts(state, HomePostSchema, getHomeState(state).homePostIds);

const getDenormalizedHomeCounsellings = createDenormalizedEntitiesSelector<HomeCounsellingEntity>();
export const getHomeCounsellings = (state: AppState): HomeCounsellingEntity[] => getDenormalizedHomeCounsellings(state, HomeCounsellingSchema, getHomeState(state).homeCounsellingIds);

const getDenormalizedHomeStrollers = createDenormalizedEntitiesSelector<StrollerMinEntity>();
export const getHomeStrollers = (state: AppState): StrollerMinEntity[] => getDenormalizedHomeStrollers(state, MinStrollerSchema, getHomeState(state).homeStrollerIds);
